import { Grid, TextField } from "@mui/material"
import { permitirApenasNumeros } from "../../../../../../../../../../helpers/masks"
import SelectBancos from "../../../../../../../../../../components/SelectsSimpleApiQuery/SelectBancos"
import { IInternForm } from "./DialogCadastrarPag"

export default function ChequeForm({
    values,
    handleChangeValues
}: ChequeFormProps) {

    return (
        <Grid container size={{xs: 12}} spacing={2}>
            <Grid size={{xs: 12, md: 6}}>
                <SelectBancos
                    value={values.cheque_banco}
                    onChange={(value) => handleChangeValues("cheque_banco", value)}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <TextField
                    required
                    fullWidth
                    label='Nº cheque'
                    type="text"
                    value={values.cheque_num || ''}
                    onChange={(e) => handleChangeValues("cheque_num", permitirApenasNumeros(e.target.value))}
                />
            </Grid>
        </Grid>
    )
}
interface ChequeFormProps {
    values: IInternForm,
    handleChangeValues: (prop: keyof IInternForm, value: any) => void
}